import { Box, Typography, Button } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import theme from '@/presentation/assets/styles/theme'
import React from 'react'
import { i18nTranslationHelper } from '@/i18n'

export interface ContactVerificationSuccessProps {
  onContinue: () => void
  title?: string
  message?: string
}

const t = { page: i18nTranslationHelper.getTPage }

export default function ContactVerificationSuccess({
  onContinue,
  title,
  message
}: ContactVerificationSuccessProps) {
  return (
    <React.Fragment>
      <Box display="flex" alignItems="center" justifyContent="center">
        <Box
          sx={{
            backgroundColor: theme.palette.success[50],
            borderRadius: '50%',
            width: 48,
            height: 48,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <CheckIcon sx={{ color: theme.palette.success[400] }} />
        </Box>
      </Box>

      <Typography variant="h6" fontWeight="bold" mb={-1}>
        {title}
      </Typography>

      <Typography variant="body1" color="grey.700" mb={1}>
        {message}
      </Typography>

      <Button variant="contained" className="w-full" onClick={onContinue} aria-label="continue">
        {t.page('contactVerification.successModal.cta')}
      </Button>
    </React.Fragment>
  )
}
